export default __webpack_public_path__ + "static/media/pdvs-alavancar.55accd1a.svg";